import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ColumnsGrid from './ColumnsGrid';
import ClientProvider from './client';
export default createDemo(import.meta.url, ColumnsGrid, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/components/grid/demos/columns/ColumnsGrid.tsx",
    "fileName": "ColumnsGrid.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/system/Box';\nimport Grid from '@mui/system/Grid';\nimport styled from '@mui/system/styled';\n\nconst Item = styled('div')(({ theme }) => ({\n  backgroundColor: '#fff',\n  border: '1px solid',\n  borderColor: '#ced7e0',\n  padding: theme.spacing(1),\n  borderRadius: '4px',\n  textAlign: 'center',\n  ...theme.applyStyles('dark', {\n    backgroundColor: '#1A2027',\n    borderColor: '#444d58',\n  }),\n}));\n\nexport default function ColumnsGrid() {\n  return (\n    <Box sx={{ flexGrow: 1 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Grid container spacing={2} columns={16}>\n        <Grid size={8}>\n          <Item>size=8</Item>\n        </Grid>\n        <Grid size={8}>\n          <Item>size=8</Item>\n        </Grid>\n      </Grid>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 31,
        "focusedLines": 8,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/system/Box';\nimport Grid from '@mui/system/Grid';\nimport styled from '@mui/system/styled';\n\nconst Item = styled('div')(({ theme }) => ({\n  backgroundColor: '#fff',\n  border: '1px solid',\n  borderColor: '#ced7e0',\n  padding: theme.spacing(1),\n  borderRadius: '4px',\n  textAlign: 'center',\n  ...theme.applyStyles('dark', {\n    backgroundColor: '#1A2027',\n    borderColor: '#444d58',\n  }),\n}));\n\nexport default function ColumnsGrid() {\n  return (\n    <Box sx={{ flexGrow: 1 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Grid container spacing={2} columns={16}>\n        <Grid size={8}>\n          <Item>size=8</Item>\n        </Grid>\n        <Grid size={8}>\n          <Item>size=8</Item>\n        </Grid>\n      </Grid>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "container"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "spacing"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "2"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "columns"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "16"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "size"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "8"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">size",
              [
                "span",
                "di-ae",
                "="
              ],
              "8</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 25
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "size"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "8"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 26
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">size",
              [
                "span",
                "di-ae",
                "="
              ],
              "8</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 27
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 28
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 31,
    "focusedLines": 8,
    "collapsible": true,
    "externals": [
      "@mui/system/Box",
      "@mui/system/Grid",
      "@mui/system/styled"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
